module.exports = __webpack_public_path__ + "static/media/04.5eea8c79.png";